import ButtonBase from '../../ButtonBase'
import { useTranslation } from 'react-i18next'

const ButtonIconWithType = ({
  title,
  type,
  disabled = false,
  icon = null,
  onClick = () => {},
  ...props
}) => {
  const { t } = useTranslation()
  return (
    // reveer porque el de icon no tine que renderizar nada
    <ButtonBase
      {...props}
      type={type}
      shape="circle"
      title={t(title)}
      disabled={disabled}
      icon={icon}
      onClick={onClick}
    />
  )
}

export default ButtonIconWithType
